import { createEnvelopeSource } from './create-envelope-source';

/**
 * RPP login-activity source (`GET /analytics/login-activity-rpp`), the same
 * measures as `login-activity` over the RPP audience. Same table and same
 * event on both sides, which is what makes them comparable at all.
 *
 * The metric ids match the ones `app-active-users` served, so the RPP
 * dashboard's Weekly and Daily cards move across by changing their source
 * alone. What changes is that they now anchor on the selected period's end
 * date rather than on today, and therefore trend.
 *
 * `activeUsersRpp` and the two trailing windows span browser and WebView,
 * deduped. `loginsRpp` and `sessionsPerUserRpp` are browser-only: a WebView
 * session is opened by the native app and never carries a login.
 */
export const loginActivityRppSource = createEnvelopeSource({
    label: 'RPP login activity',
    endpoint: 'analytics/login-activity-rpp',
    metrics: [
        { id: 'activeUsersRpp', label: 'RPP active users', type: 'scalar' },
        {
            id: 'weeklyActiveUsersRpp',
            label: 'RPP weekly active users',
            type: 'scalar',
        },
        {
            id: 'dailyActiveUsersRpp',
            label: 'RPP daily active users',
            type: 'scalar',
        },
        { id: 'loginsRpp', label: 'RPP logins', type: 'scalar' },
        {
            id: 'sessionsPerUserRpp',
            label: 'RPP sessions per user',
            type: 'ratio',
        },
    ],
    forms: ['number', 'rate', 'bars', 'pie'],
    regionGrain: 'province',
});
